package com.tovtalk.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class KosherLevelDto(
    @SerialName("id") val id: Int,
    @SerialName("order") val order: Int,
    @SerialName("allowed_on_hadran") val allowedOnHadran: Boolean,
    @SerialName("requires_gender_verification") val requiresGenderVerification: Boolean,
    @SerialName("name_key") val nameKey: String,
    @SerialName("description_key") val descriptionKey: String? = null,
    @SerialName("name") val name: String? = null,
    @SerialName("description") val description: String? = null,
    @SerialName("name_he") val nameHe: String? = null,
    @SerialName("name_en") val nameEn: String? = null,
    @SerialName("allow_text_comments") val allowTextComments: Boolean = true,
    @SerialName("allow_emoji_reactions") val allowEmojiReactions: Boolean = true,
)
